import { Core, formValidation } from "@form-validation/bundle/full";
import { Bootstrap5 } from "@form-validation/plugin-bootstrap5";
import { Excluded } from "@form-validation/plugin-excluded";
import { Trigger } from "@form-validation/plugin-trigger";

class CmsBootstrap5 extends Bootstrap5 {
  prepareElementContainer(field: string, element: HTMLElement): void {
    const opts = (this as any).opts;
    const selector = typeof opts.rowSelector === "string"
      ? opts.rowSelector
      : opts.rowSelector(field, element);
    const groupEle = element?.closest ? element.closest(selector) : null;

    if (groupEle && groupEle !== element) {
      const classes = [opts.rowClasses, "fv-plugins-icon-container"].filter(
        (cls): cls is string => typeof cls === "string" && cls.trim().length > 0
      );

      if (classes.length > 0) {
        groupEle.classList.add(...classes);
      }

      (this as any).containers.set(element, groupEle);
    }
  }

  onMessagePlaced(e: any): void {
    const inputParent = e.element?.parentElement;
    const row = e.element.closest(".fv-row");
    const target = row?.querySelector(".fv-validation-message");

    if (!target) {
      super.onMessagePlaced(e);
      return;
    }

    if (e.messageElement.parentElement === target) {
      return;
    }

    e.messageElement.classList.add("invalid-feedback");
    target.appendChild(e.messageElement);

    if (inputParent?.classList?.contains("input-group")) {
      inputParent.classList.add("has-validation");
    }
  }
}

export const createFormValidation = (formElement: HTMLFormElement, config: any): Core => {
  const resolvedFields: any = config?.fields ?? config;
  const { fields: _fields, plugins, ...options } = config ?? {};

  return formValidation(formElement, {
    ...options,
    fields: resolvedFields,
    plugins: {
      ...(plugins ?? {}),
      bootstrap5: new CmsBootstrap5({
        formClass: "fv-plugins-bootstrap5",
        rowInvalidClass: "fv-plugins-bootstrap5-row-invalid",
        rowPattern: /^(.*)(col|offset)(-(sm|md|lg|xl))*-[0-9]+(.*)$/,
        rowSelector: ".fv-row, .form-group, .mb-2, .mb-3, .mb-4, .col, [class*='col-']",
        rowValidClass: "fv-plugins-bootstrap5-row-valid"
      }),
      trigger: new Trigger({
        event: "input blur change"
      }),
      excluded: new Excluded()
    }
  });
};

export const isFormValid = async (fvinst: Core | null | undefined): Promise<boolean> => {
  if (!fvinst) {
    return false;
  }

  const res = await fvinst.validate();
  return res === "Valid";
};

export const isFieldValid = async (fvinst: Core | null | undefined, fieldname: string): Promise<boolean> => {
  if (!fvinst) {
    return false;
  }

  const res = await fvinst.validateField(fieldname);
  return res === "Valid";
};
